import { AppNS } from 'app';
import { ApiCollectionResponse, Params } from 'app/types';

import { getCollectionResponse, request } from '../config';

const INVITATIONS_URL = 'invitations';
const EMPLOYMENTS_URL = 'employments';

export function apiGetAgencyStaff(
  companyId: string,
  data: Params,
  signal?: AbortSignal
): Promise<ApiCollectionResponse<AppNS.Invitation>> {
  return request(
    {
      url: `${INVITATIONS_URL}.json`,
      method: 'GET',
      params: { ...data, companyId },
      signal,
    },
    (data) => getCollectionResponse<AppNS.Invitation>(data)
  );
}

export function apiCreateInvitation(data: Partial<AppNS.Invitation>, signal?: AbortSignal): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}.json`,
      method: 'POST',
      data: {
        invitation: data,
      },
      signal,
    },
    (data) => data.model
  );
}

export function apiUpdateEmployment(
  id: string,
  data: Partial<AppNS.Invitation>,
  signal?: AbortSignal
): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${EMPLOYMENTS_URL}/${id}.json`,
      method: 'PATCH',
      data: {
        employment: data,
      },
      signal,
    },
    (data) => data.model
  );
}

export function apiDeleteInvitation(id: string, signal?: AbortSignal): Promise<string> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}.json`,
      method: 'DELETE',
      signal,
    },
    (data) => data.model.id
  );
}

export function apiGetInvitationById(id: string, signal?: AbortSignal): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}.json`,
      method: 'GET',
      signal,
    },
    (data) => data.model
  );
}

export function apiGetUserEmployments(params: AppNS.Params, signal?: AbortSignal): Promise<AppNS.Employment[]> {
  return request(
    {
      url: `${EMPLOYMENTS_URL}.json`,
      method: 'GET',
      params,
      signal,
    },
    (data) => data.models.results
  );
}
